import React, { useState } from "react";
import { Button, Input, Label, Spinner } from "reactstrap";
import { FiSend } from "react-icons/fi";

/**
 * Reply composer shown inside the ticket detail drawer. Submits via the
 * parent's onSubmit(body) which calls the backend reply endpoint. The parent
 * refreshes the conversation thread on success.
 */
const SupportReplyForm = ({ onSubmit, submitting }) => {
    const [body, setBody] = useState("");
    const [touched, setTouched] = useState(false);

    const invalid = touched && !body.trim();

    const handleSend = async () => {
        setTouched(true);
        if (!body.trim()) return;
        const ok = await onSubmit(body.trim());
        if (ok) {
            setBody("");
            setTouched(false);
        }
    };

    return (
        <div>
            <Label className="form-label fw-medium">Add a reply</Label>
            <Input
                type="textarea"
                rows={4}
                value={body}
                onChange={(e) => setBody(e.target.value)}
                onBlur={() => setTouched(true)}
                placeholder="Type your reply to the requester…"
                invalid={invalid}
                disabled={submitting}
            />
            {invalid && (
                <div className="text-danger small mt-1">Reply cannot be empty.</div>
            )}
            <div className="text-end mt-2">
                <Button color="primary" onClick={handleSend} disabled={submitting}>
                    {submitting ? (
                        <Spinner size="sm" className="me-1" />
                    ) : (
                        <FiSend className="me-1" />
                    )}
                    Send reply
                </Button>
            </div>
        </div>
    );
};

export default SupportReplyForm;
